import * as Long from "long";
import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { selectCurrentDialogGift } from "../../../selectors/selectTournamentRewards";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionExpenseConfirmed } from "../../item-packages/actionPackages";
import { TypeActionTournament } from "../actionTournament";
export var epicTournamentRequestPackageFromCurrentReward = function (action$, state$) {
    return action$.pipe(ofType(TypeActionTournament.RequestPackageFromCurrentReward), switchMap(function () {
        var state = state$.value;
        var currentGift = selectCurrentDialogGift(state);
        if (!currentGift) {
            return EMPTY;
        }
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var goldRequired = !currentGift.cost || !currentGift.cost[0]
            ? Long.ZERO
            : Long.fromValue(currentGift.cost[0].amount);
        var playerGold = playerGoldInfo.amount || Long.ZERO;
        return of(actionBeginBuyWithGoldProcess(playerGold, goldRequired, actionExpenseConfirmed(currentGift.id)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentRequestPackageFromCurrentReward.ts
// module id = 2445
// module chunks = 3